import { ReactNode } from "react";
import { Background } from "./__styles__/FullPageBackgroundWithLogo";

export default ({ children }: { children?: ReactNode }) => {
  return <Background>{children}</Background>;
};
